import Header from "../components/Header";
import Signup from "../components/Signup.js";
import Footer from "../components/Footer";

import "./styles.css"

export default function ContactUs() {
  return (
    <div className="CreateAccount">
      <Header></Header>
      <Signup></Signup>
      <Footer></Footer>
    </div>
  );
}
